import { CheckedCircleIcon, ClosedCircleIcon, CrossIcon } from 'assets/icons';
import { useState } from 'react';
import styled from 'styled-components';

type AlertType = 'error' | 'success' | 'info';

export const Alert = ({
  type = 'success',
  children = '',
  closeable = false,
}: {
  type: AlertType;
  children: React.ReactNode;
  closeable?: boolean;
}) => {
  const [showAlert, setShowAlert] = useState(true);

  return showAlert ? (
    <Wrap type={type}>
      <IconWrap>
        {type === 'success' && <CheckedCircleIcon />}
        {type === 'error' && <ClosedCircleIcon />}
      </IconWrap>
      <MessageWrap>{children}</MessageWrap>
      {closeable && (
        <CloseableWrap onClick={() => setShowAlert(false)}>
          <CrossIcon />
        </CloseableWrap>
      )}
    </Wrap>
  ) : (
    <></>
  );
};
const Wrap = styled.div<{ type: AlertType }>`
  background: ${props => {
    switch (props.type) {
      case 'success':
        return '#E7F8F2';
      case 'error':
        return '#FFEDEB';
      case 'info':
        return '#E6F4FF';
      default:
        return '#E7F8F2';
    }
  }};
  color: ${props => {
    switch (props.type) {
      case 'success':
        return '#0D9467';
      case 'error':
        return '#FA4F38';
      case 'info':
        return '#1890FF';
      default:
        return '#0D9467';
    }
  }};
  display: flex;
  border-radius: 8px;
  padding: 10px 14px;
  align-items: center;

  /* Text sm/Semibold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

const IconWrap = styled.div`
  margin-right: 8px;
`;
const MessageWrap = styled.div`
  button {
    background: none;
    border: none;
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    margin: 0;
    padding: 0;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const CloseableWrap = styled.div`
  cursor: pointer;
`;
